import {
  ActionType,
  IPatientListResponse,
  PatientsPayload,
} from "models/patients/patientList";

export const getPatientListAction = (payload: PatientsPayload) => {
  return {
    type: ActionType.GET_PATIENT_LIST,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_PATIENT_LIST_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IPatientListResponse) => {
  return {
    type: ActionType.GET_PATIENT_LIST_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.GET_PATIENT_LIST_RESET,
  };
};
